(function () {
  'use strict';

  if (customElements.get('vl-homepage-rider-quiz')) return;

  class VlHomepageRiderQuiz extends HTMLElement {}
  customElements.define('vl-homepage-rider-quiz', VlHomepageRiderQuiz);

  var root = document.querySelector('vl-homepage-rider-quiz');
  if (!root) return;

  var configNode = root.querySelector('[data-vl-homepage-rider-quiz-config]');
  var config;

  try {
    config = JSON.parse(configNode.textContent);
  } catch (error) {
    return;
  }

  /**
   * ============================================================
   * QUIZ BRANCH CONFIG
   * ============================================================
   *
   * 第一问 -> 第二问
   *
   * 如果后续 Liquid/config 中已经提供：
   *
   * riderTypes: [
   *   {
   *     value: 'around_town',
   *     followup: {
   *       question: '...',
   *       answers: [...]
   *     }
   *   }
   * ]
   *
   * 会优先使用 config 中的 followup。
   *
   * 否则使用下面需求文档中的正式配置。
   */

  var FOLLOWUP_CONFIG = {
    around_town: {
      question: 'Last question: How will you use your ebike?',
      answers: [
        {
          value: 'commuting',
          label: 'Commuting'
        },
        {
          value: 'leisure_and_fun',
          label: 'Leisure & fun'
        },
        {
          value: 'exercise',
          label: 'Exercise'
        }
      ]
    },

    outdoors: {
      question: "Last question: How will you use your ebike?",
      answers: [
        {
          value: 'trails_exploring',
          label: 'Trails & exploring'
        },
        {
          value: 'camping_rv_trips',
          label: 'Camping & RV trips'
        }
      ]
    },

    both: {
      question: 'Last question: How will you use your ebike?',
      answers: [
        {
          value: 'commuting',
          label: 'Commuting'
        },
        {
          value: 'leisure_and_fun',
          label: 'Leisure & fun'
        },
        {
          value: 'exercise',
          label: 'Exercise'
        }
      ]
    }
  };

  /**
   * ============================================================
   * RIDER TYPE + DETAIL -> RIDER SEGMENT
   * ============================================================
   */

  var RESULT_MAPPING = {
    around_town: {
      commuting: 'comfort',
      leisure_and_fun: 'comfort',
      exercise: 'power'
    },

    outdoors: {
      trails_exploring: 'exploration',
      camping_rv_trips: 'exploration'
    },

    both: {
      commuting: 'comfort',
      leisure_and_fun: 'comfort',
      exercise: 'power'
    }
  };

  var RECOMMENDATION_CONFIG = {
    around_town: {
      model: 'discover_3',
      label: 'Discover 3',
      bannerVariantKey: 'discover_3'
    },
    outdoors: {
      model: 'nomad_2x',
      label: 'Nomad 2X',
      bannerVariantKey: 'nomad_2x'
    },
    both: {
      model: 'summit_2',
      label: 'Summit 2',
      bannerVariantKey: 'summit_2'
    }
  };

  var EMAIL_CONTENT_MAPPING = {
    commuting: 'cruise_commute',
    leisure_and_fun: 'cruise_commute',
    exercise: 'fitness',
    trails_exploring: 'recreation_adventure',
    camping_rv_trips: 'recreation_adventure'
  };

  /**
   * ============================================================
   * RIDER SEGMENT -> RESULT
   * ============================================================
   */

  var RESULT_CONFIG = {
    comfort: {
      animal: 'bison',
      emoji: '🦬',
      title: 'Your Rider Type: Bison',
      personality: 'You’re an easygoing rider who knows a good ride doesn’t need to be rushed. You’ll likely feel at home on a smooth, upright cruiser e-bike.',
      controlLabel: 'Comfort Cruiser'
    },

    exploration: {
      animal: 'eagle',
      emoji: '🦅',
      title: 'Your Rider Type: Eagle',
      personality: 'You’re a curious explorer who may occasionally rename a wrong turn “the scenic route.” A long-range adventure e-bike could be your ideal companion.',
      controlLabel: 'Weekend Explorer'
    },

    power: {
      animal: 'mustang',
      emoji: '🐎',
      title: 'Your Rider Type: Mustang',
      personality: 'You’re a spirited rider who sees a steep hill as an interesting suggestion. A responsive performance e-bike with plenty of power may suit you best.',
      controlLabel: 'Power Rider'
    }
  };

  /**
   * ============================================================
   * STATE
   * ============================================================
   */

  var state = {
    step: 1,

    riderType: null,
    detail: null,

    riderSegment: null,
    animalRiderType: null,
    personalityCopy: null,
    controlLabel: null,
    recommendedModel: null,
    recommendedModelLabel: null,
    emailContentSegment: null,

    email: '',

    open: false,
    opening: false,
    reopenAvailable: false,
    reopenDismissed: false,

    lastFocus: null,

    submitted: false,
    submitting: false,

    assignedGroup: null,
    actualExposure: false,
    activeKlaviyoFormId: null
  };

  var analyticsState = {
    answeredQuestions: {},
    completed: false,
    popupImpressionCount: 0,
    gtagSentCount: 0,
    gtagFailedCount: 0,
    bannerImpressions: {},
    banner: {
      applied: false,
      status: 'idle',
      lastError: null,
      deviceResults: {},
      contentId: null,
      target: null,
      container: null,
      imageLoaded: false,
      impressionSent: false,
      visibilityTimer: null,
      observer: null
    }
  };

  var host = root;

  /**
   * ============================================================
   * HELPERS
   * ============================================================
   */

  function emit(name, detail) {
    host.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        detail: detail || {}
      })
    );
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(
      /[&<>'"]/g,
      function (char) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          "'": '&#39;',
          '"': '&quot;'
        }[char];
      }
    );
  }

  function getKlaviyoConfig() {
    return config.klaviyo || {};
  }

  function getCoordinator() {
    return window.VLWelcomePopupCoordinator || null;
  }

  function getAnalyticsConfig() {
    return config.analytics || {};
  }

  function analyticsEnabled() {
    return getAnalyticsConfig().enabled !== false;
  }

  function getDeviceVariant() {
    return window.matchMedia &&
      window.matchMedia('(max-width: 749px)').matches
      ? 'mobile'
      : 'desktop';
  }

  function sanitizedProperties(properties) {
    var result = {};

    Object.keys(properties || {}).forEach(function (key) {
      var value = properties[key];

      if (
        value !== null &&
        value !== undefined &&
        ['string', 'number', 'boolean'].indexOf(typeof value) !== -1
      ) {
        result[key] = value;
      }
    });

    return result;
  }

  function commonPopupProperties() {
    return {
      experiment_variant: state.assignedGroup || 'quiz',
      device: getDeviceVariant()
    };
  }

  function mergeProperties(base, extra) {
    var result = {};

    Object.keys(base || {}).forEach(function (key) {
      result[key] = base[key];
    });
    Object.keys(extra || {}).forEach(function (key) {
      result[key] = extra[key];
    });

    return result;
  }

  function trackGtagEvent(eventName, properties) {
    if (!analyticsEnabled()) return Promise.resolve(false);

    var payload = sanitizedProperties(properties);

    try {
      // The site loads Google tags asynchronously. Queue standard gtag commands
      // in dataLayer when the global helper has not been created yet.
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };

      window.gtag('event', eventName, payload);
      analyticsState.gtagSentCount += 1;
      emit('vl:homepage-popup-analytics-sent', {
        platform: 'gtag',
        eventName: eventName,
        properties: payload
      });
      return Promise.resolve(true);
    } catch (error) {
      analyticsState.gtagFailedCount += 1;
      emit('vl:homepage-popup-analytics-failed', {
        platform: 'gtag',
        eventName: eventName,
        reason: 'gtag_failed'
      });
      return Promise.resolve(false);
    }
  }

  function trackPopupImpression() {
    analyticsState.popupImpressionCount += 1;

    trackGtagEvent(
      'homepage_popup_impression',
      mergeProperties(commonPopupProperties(), {
        entry_step: state.step,
        impression_number: analyticsState.popupImpressionCount
      })
    );
  }

  function answeredCount() {
    return Object.keys(analyticsState.answeredQuestions).length;
  }

  function trackPopupAnswer(questionId, answerId, stepNumber) {
    if (!questionId || !answerId) return;

    var previousAnswer = analyticsState.answeredQuestions[questionId];
    if (previousAnswer === answerId) return;
    analyticsState.answeredQuestions[questionId] = answerId;

    trackGtagEvent(
      'homepage_popup_answered',
      mergeProperties(commonPopupProperties(), {
        answer_id: answerId,
        step_number: stepNumber,
        answer_action: previousAnswer && previousAnswer !== answerId
          ? 'changed'
          : 'initial'
      })
    );
  }

  function closeStepName() {
    if (state.step === 1) return 'q1';
    if (state.step === 2) return 'q2';
    return 'result_email';
  }

  function trackPopupClosed(closeMethod, closedAt) {
    if (analyticsState.completed) return;

    trackGtagEvent(
      'homepage_popup_closed',
      mergeProperties(commonPopupProperties(), {
        closed_at: closedAt || closeStepName(),
        close_method: closeMethod || 'unknown',
        answered_count: answeredCount()
      })
    );
  }

  function trackPopupCompleted() {
    if (analyticsState.completed) return;

    analyticsState.completed = true;
    trackGtagEvent(
      'homepage_popup_completed',
      mergeProperties(commonPopupProperties(), {
        completion_type: 'email_signup',
        answered_count: answeredCount()
      })
    );
  }

  function coordinatorIsRequired() {
    return !config.coordinator || config.coordinator.required !== false;
  }

  /**
   * 找到当前第一问的配置。
   */
  function getRiderTypeConfig(riderType) {
    if (!Array.isArray(config.riderTypes)) return null;

    for (var i = 0; i < config.riderTypes.length; i++) {
      if (config.riderTypes[i].value === riderType) {
        return config.riderTypes[i];
      }
    }

    return null;
  }

  /**
   * 获取第二问配置。
   *
   * 优先：
   * config.riderTypes[x].followup
   *
   * fallback：
   * FOLLOWUP_CONFIG
   */
  function getFollowupConfig(riderType) {
    var riderConfig = getRiderTypeConfig(riderType);

    if (
      riderConfig &&
      riderConfig.followup &&
      riderConfig.followup.question &&
      Array.isArray(riderConfig.followup.answers)
    ) {
      return riderConfig.followup;
    }

    return FOLLOWUP_CONFIG[riderType] || null;
  }

  /**
   * 为第二问答案补 icon。
   *
   * 1. answer.icon 优先
   * 2. 按稳定答案 value 匹配 config.details，避免不同分支按位置串图。
   */
  function getDetailIcon(answer, index) {
    if (answer && answer.icon) {
      return answer.icon;
    }

    if (
      Array.isArray(config.details) &&
      answer
    ) {
      var detail = config.details.find(function (item) {
        return item.value === answer.value;
      });
      return detail && detail.icon ? detail.icon : '';
    }

    return '';
  }

  /**
   * 检查 detail 是否属于当前 rider type。
   */
  function isValidDetail(riderType, detail) {
    var followup = getFollowupConfig(riderType);

    if (!followup || !Array.isArray(followup.answers)) {
      return false;
    }

    return followup.answers.some(function (answer) {
      return answer.value === detail;
    });
  }

  /**
   * 第一问 + 第二问 -> rider segment
   */
  function getRiderSegment(riderType, detail) {
    if (
      !RESULT_MAPPING[riderType] ||
      !RESULT_MAPPING[riderType][detail]
    ) {
      return null;
    }

    return RESULT_MAPPING[riderType][detail];
  }

  /**
   * 根据当前两个答案计算完整结果。
   */
  function calculateResult() {
    var segment = getRiderSegment(
      state.riderType,
      state.detail
    );

    if (!segment) {
      return null;
    }

    var resultConfig = RESULT_CONFIG[segment];
    var recommendation = RECOMMENDATION_CONFIG[state.riderType];
    var emailContentSegment = EMAIL_CONTENT_MAPPING[state.detail];

    if (!resultConfig || !recommendation || !emailContentSegment) {
      return null;
    }

    return {
      riderSegment: segment,
      animalRiderType: resultConfig.animal,
      emoji: resultConfig.emoji,
      title: resultConfig.title,
      personality: resultConfig.personality,
      controlLabel: resultConfig.controlLabel,
      recommendedModel: recommendation.model,
      recommendedModelLabel: recommendation.label,
      bannerVariantKey: recommendation.bannerVariantKey,
      emailContentSegment: emailContentSegment,
      mappingVersion: '2'
    };
  }

  /**
   * 把计算结果同步到 state。
   */
  function updateResultState() {
    var result = calculateResult();

    if (!result) {
      state.riderSegment = null;
      state.animalRiderType = null;
      state.personalityCopy = null;
      state.controlLabel = null;
      state.recommendedModel = null;
      state.recommendedModelLabel = null;
      state.emailContentSegment = null;

      return false;
    }

    state.riderSegment = result.riderSegment;
    state.animalRiderType = result.animalRiderType;
    state.personalityCopy = result.personality;
    state.controlLabel = result.controlLabel;
    state.recommendedModel = result.recommendedModel;
    state.recommendedModelLabel = result.recommendedModelLabel;
    state.emailContentSegment = result.emailContentSegment;

    return true;
  }

  /**
   * 当第一问改变时清除旧分支结果。
   */
  function resetDetailResult() {
    state.detail = null;
    state.riderSegment = null;
    state.animalRiderType = null;
    state.personalityCopy = null;
    state.controlLabel = null;
    state.recommendedModel = null;
    state.recommendedModelLabel = null;
    state.emailContentSegment = null;
  }

  function persistQuizProgress() {
    var coordinator = getCoordinator();
    if (!coordinator || typeof coordinator.saveQuizProgress !== 'function') return;
    coordinator.saveQuizProgress({
      version: '2',
      step: state.step,
      riderType: state.riderType,
      riderDetail: state.detail
    });
  }

  function restoreQuizProgress() {
    var coordinator = getCoordinator();
    if (!coordinator || typeof coordinator.getQuizProgress !== 'function') return;
    var progress = coordinator.getQuizProgress();
    if (!progress || String(progress.version || '') !== '2') return;

    if (!getFollowupConfig(progress.riderType)) return;
    state.riderType = progress.riderType;
    state.step = 2;

    var recommendation = RECOMMENDATION_CONFIG[state.riderType];
    state.recommendedModel = recommendation ? recommendation.model : null;
    state.recommendedModelLabel = recommendation ? recommendation.label : null;

    if (isValidDetail(state.riderType, progress.riderDetail)) {
      state.detail = progress.riderDetail;
      if (updateResultState()) state.step = 3;
    }

    if (recommendation) personalizeHomepageBanner(recommendation.bannerVariantKey);
  }

  /**
   * ============================================================
   * UI
   * ============================================================
   */

  function closeButton() {
    return (
      '<button type="button" ' +
      'class="vl-homepage-rider-quiz__close" ' +
      'data-action="close" ' +
      'aria-label="Close">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" ' +
      'viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M4.99132 4.40207C5.15404 4.23935 5.41786 4.23935 ' +
      '5.58058 4.40207L10 8.82149L14.4194 4.40207C14.5821 4.23935 ' +
      '14.846 4.23935 15.0087 4.40207L15.5979 4.99133C15.7606 ' +
      '5.15405 15.7606 5.41786 15.5979 5.58058L11.1785 10L15.5979 ' +
      '14.4194C15.7606 14.5821 15.7606 14.846 15.5979 15.0087L15.0087 ' +
      '15.5979C14.846 15.7606 14.5821 15.7606 14.4194 15.5979L10 ' +
      '11.1785L5.58058 15.5979C5.41786 15.7606 5.15404 15.7606 ' +
      '4.99132 15.5979L4.40207 15.0087C4.23935 14.846 4.23935 ' +
      '14.5821 4.40207 14.4194L8.82149 10L4.40207 5.58058C4.23935 ' +
      '5.41786 4.23935 5.15405 4.40207 4.99133L4.99132 4.40207Z" ' +
      'fill="#434343"/></svg>' +
      '</button>'
    );
  }

  function findBannerVariant(key) {
    var variants = document.querySelectorAll(
      '[data-vl-rider-banner-variant]'
    );

    for (var i = 0; i < variants.length; i++) {
      if (
        variants[i].getAttribute(
          'data-vl-rider-banner-variant'
        ) === key
      ) {
        return variants[i];
      }
    }

    return null;
  }

  function stopBannerVisibilityTimer() {
    if (analyticsState.banner.visibilityTimer) {
      window.clearTimeout(analyticsState.banner.visibilityTimer);
      analyticsState.banner.visibilityTimer = null;
    }
  }

  function disconnectBannerObserver() {
    stopBannerVisibilityTimer();

    if (analyticsState.banner.observer) {
      analyticsState.banner.observer.disconnect();
      analyticsState.banner.observer = null;
    }
  }

  function scheduleBannerImpression() {
    var banner = analyticsState.banner;
    var delayMs = Number(getAnalyticsConfig().bannerVisibilityMs) || 1000;

    stopBannerVisibilityTimer();

    if (
      !banner.applied ||
      !banner.imageLoaded ||
      !banner.inView ||
      banner.impressionSent ||
      state.open ||
      document.visibilityState === 'hidden'
    ) {
      return;
    }

    banner.visibilityTimer = window.setTimeout(function () {
      banner.visibilityTimer = null;

      if (
        !banner.applied ||
        !banner.imageLoaded ||
        !banner.inView ||
        banner.impressionSent ||
        state.open ||
        document.visibilityState === 'hidden'
      ) {
        return;
      }

      banner.impressionSent = true;
      analyticsState.bannerImpressions[banner.contentId] = true;
    }, delayMs);
  }

  function prepareBannerAnalytics(key, applied) {
    disconnectBannerObserver();

    var banner = analyticsState.banner;
    var device = getDeviceVariant();
    var target = document.querySelector(
      '[data-vl-rider-banner-target="' + device + '"]'
    );
    var container = document.querySelector(
      '[data-vl-rider-banner-container="' + device + '"]'
    );

    banner.applied = Boolean(applied && target && container);
    banner.contentId = key ? key + '_banner' : null;
    banner.target = target;
    banner.container = container;
    banner.imageLoaded = false;
    banner.inView = false;
    banner.impressionSent = Boolean(
      banner.contentId && analyticsState.bannerImpressions[banner.contentId]
    );

    if (!banner.applied) return;

    var image = target.tagName === 'SOURCE'
      ? (target.closest('picture') || container).querySelector('img')
      : target;

    function markImageLoaded() {
      if (banner.target !== target || !image.complete || image.naturalWidth <= 160) return;
      banner.imageLoaded = true;
      image.removeEventListener('load', markImageLoaded);
      scheduleBannerImpression();
    }

    if (image && image.complete && image.naturalWidth > 160) {
      markImageLoaded();
    } else if (image) {
      image.addEventListener('load', markImageLoaded);
    }

    if (typeof window.IntersectionObserver !== 'function') return;

    var ratio = Number(getAnalyticsConfig().bannerVisibilityRatio);
    if (!(ratio > 0 && ratio <= 1)) ratio = 0.5;

    banner.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target !== banner.container) return;

        banner.inView = entry.isIntersecting && entry.intersectionRatio >= ratio;
        if (banner.inView) {
          scheduleBannerImpression();
        } else {
          stopBannerVisibilityTimer();
        }
      });
    }, { threshold: [ratio] });

    banner.observer.observe(container);
  }

  var bannerRequestVersion = 0;

  function loadBannerImage(image, width) {
    if (!image) return Promise.reject(new Error('banner_image_missing'));
    return new Promise(function (resolve, reject) {
      var settled = false;
      var loader = new window.Image();
      var timer = window.setTimeout(function () {
        finish(new Error('banner_image_timeout'));
      }, 15000);
      function finish(error) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        loader.onload = null;
        loader.onerror = null;
        if (error) reject(error);
        else resolve();
      }
      function failed() { finish(new Error('banner_image_failed')); }
      function loaded() {
        if (!loader.naturalWidth) return failed();

        image.src = selectedUrl;
        image.removeAttribute('srcset');
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-sizes');

        // `load` + naturalWidth proves the resource is complete and cached.
        // Waiting for decode() is unreliable for very wide images and SVGs;
        // Chrome can leave that promise pending even after a successful load.
        finish();
      }

      image.loading = 'eager';
      image.classList.remove('lazyload', 'lazyloading');
      image.classList.add('lazyloaded');

      var srcset = image.getAttribute('data-srcset');
      var selectedUrl = image.getAttribute('src');
      if (srcset) {
        var requestedWidth = Math.ceil(
          width * Math.min(window.devicePixelRatio || 1, 2)
        );
        var candidates = [];

        srcset.replace(/(\S+)\s+(\d+)w/g, function (_, url, candidateWidth) {
          candidates.push({
            // Shopify's srcset output has no whitespace after commas, so the
            // generic token match includes the preceding comma from item 2+.
            url: url.replace(/^,+/, ''),
            width: Number(candidateWidth)
          });
          return _;
        });

        candidates.sort(function (a, b) {
          return a.width - b.width;
        });

        var selectedCandidate = candidates[candidates.length - 1];
        for (var i = 0; i < candidates.length; i++) {
          if (candidates[i].width >= requestedWidth) {
            selectedCandidate = candidates[i];
            break;
          }
        }

        image.sizes = Math.ceil(width) + 'px';
        if (selectedCandidate) selectedUrl = selectedCandidate.url;
      }

      if (!selectedUrl) return failed();

      // Images cloned from <template> do not reliably start loading while
      // detached. Load through a standalone probe, then insert the fully
      // cached banner in one DOM replacement so the old card never blanks.
      loader.onload = loaded;
      loader.onerror = failed;
      loader.src = selectedUrl;

      if (loader.complete && loader.naturalWidth > 0) loaded();
    });
  }

  function personalizeHomepageBanner(key) {
    var version = ++bannerRequestVersion;
    disconnectBannerObserver();
    analyticsState.banner.applied = false;
    analyticsState.banner.status = 'loading';
    analyticsState.banner.lastError = null;
    analyticsState.banner.deviceResults = {};
    var appliedDevices = { desktop: false, mobile: false };
    var pending = ['desktop', 'mobile'].map(function (device) {
      var template = document.querySelector(
        '[data-vl-rider-banner-template="' + key + '"][data-vl-rider-banner-device="' + device + '"]'
      );
      var current = document.querySelector(
        '[data-vl-rider-banner-container="' + device + '"]'
      );
      if (!template || !current) {
        analyticsState.banner.deviceResults[device] = !template
          ? 'template_missing'
          : 'target_missing';
        return Promise.resolve();
      }
      current.setAttribute('data-vl-rider-banner-load-status', 'loading');
      var fragment = template.content.cloneNode(true);
      var next = fragment.querySelector('[data-vl-rider-banner-container]');
      if (!next) {
        analyticsState.banner.deviceResults[device] = 'template_container_missing';
        return Promise.resolve();
      }
      next.setAttribute('data-vl-rider-banner-personalized', key);
      var logo = next.querySelector('.vl-rider-banner__logo');
      var width = current.getBoundingClientRect().width ||
        (device === 'mobile' ? window.innerWidth : window.innerWidth / 2);
      var imageReady = loadBannerImage(next.querySelector('[data-vl-rider-banner-target]'), width);
      var logoReady = logo ? loadBannerImage(logo, 300).catch(function () {
        logo.parentNode.textContent = logo.alt;
      }) : Promise.resolve();
      return Promise.all([imageReady, logoReady]).then(function () {
        if (version !== bannerRequestVersion) {
          analyticsState.banner.deviceResults[device] = 'request_superseded';
          current.setAttribute(
            'data-vl-rider-banner-load-status',
            'request_superseded'
          );
          return;
        }
        if (!current.isConnected) {
          analyticsState.banner.deviceResults[device] = 'target_disconnected';
          return;
        }
        next.setAttribute('data-vl-rider-banner-load-status', 'applied');
        current.replaceWith(fragment);
        appliedDevices[device] = true;
        analyticsState.banner.deviceResults[device] = 'applied';
      }).catch(function (error) {
        var reason = error && error.message
          ? error.message
          : 'banner_unknown_error';
        analyticsState.banner.deviceResults[device] = reason;
        analyticsState.banner.lastError = reason;
        if (current.isConnected) {
          current.setAttribute('data-vl-rider-banner-load-status', reason);
        }
        // Keep the original card when the selected image cannot be loaded.
      });
    });
    return Promise.all(pending).then(function () {
      if (version !== bannerRequestVersion) return false;
      var applied = appliedDevices.desktop || appliedDevices.mobile;
      analyticsState.banner.status = applied ? 'applied' : 'failed';
      if (!applied && !analyticsState.banner.lastError) {
        analyticsState.banner.lastError = 'banner_target_or_template_missing';
      }
      emit('vl:homepage-collage-personalized', {
        bannerVariantKey: key,
        applied: applied,
        desktopApplied: appliedDevices.desktop,
        mobileApplied: appliedDevices.mobile,
        deviceResults: analyticsState.banner.deviceResults,
        error: analyticsState.banner.lastError
      });
      prepareBannerAnalytics(key, appliedDevices[getDeviceVariant()]);
      return applied;
    });
  }

  function shell(content) {
    return (
      '<div class="vl-homepage-rider-quiz" ' +
      'role="dialog" ' +
      'aria-modal="true" ' +
      'aria-labelledby="vl-homepage-rider-quiz-title">' +
      '<div class="vl-homepage-rider-quiz__panel">' +
      closeButton() +
      content +
      '</div>' +
      '</div>'
    );
  }

  function intro(includeEyebrow) {
    return (
      '<div class="vl-homepage-rider-quiz__intro">' +

      (includeEyebrow
        ? '<p class="vl-homepage-rider-quiz__eyebrow">' +
          escapeHtml(config.copy.lastQuestion) +
          '</p>'
        : '') +

      '<h2 id="vl-homepage-rider-quiz-title" ' +
      'class="vl-homepage-rider-quiz__title">' +
      'Find Your Perfect<br>Ebike in 2 Steps' +
      '</h2>' +

      '<p class="vl-homepage-rider-quiz__subtitle">' +
      escapeHtml(config.copy.subtitle) +
      '</p>' +

      '</div>'
    );
  }

  /**
   * ============================================================
   * STEP 1
   * ============================================================
   */

  function riderStep() {
    var options = config.riderTypes
      .map(function (item) {
        var selected =
          state.riderType === item.value
            ? ' is-selected'
            : '';

        return (
          '<button type="button" ' +
          'class="vl-homepage-rider-quiz__option ' +
          'vl-homepage-rider-quiz__option--rider' +
          selected +
          '" ' +
          'data-rider="' +
          escapeHtml(item.value) +
          '">' +

          '<img src="' +
          escapeHtml(item.image) +
          '" alt="">' +

          '<span class="vl-homepage-rider-quiz__option-label">' +
          escapeHtml(item.label) +
          '</span>' +

          '</button>'
        );
      })
      .join('');

    return shell(
      intro(false) +

        '<div class="vl-homepage-rider-quiz__main">' +

        '<h3 class="vl-homepage-rider-quiz__question">' +
        escapeHtml(config.copy.questionOne) +
        '</h3>' +

        '<div class="vl-homepage-rider-quiz__options">' +
        options +
        '</div>' +

        '</div>'
    );
  }

  /**
   * ============================================================
   * STEP 2 - DYNAMIC
   * ============================================================
   */

  function detailStep() {
    var followup = getFollowupConfig(state.riderType);

    /**
     * 理论上不会发生。
     * 如果 riderType 没有对应配置，则不给错误分支。
     */
    if (!followup) {
      return shell(
        intro(true) +
          '<div class="vl-homepage-rider-quiz__main">' +
          '<p class="vl-homepage-rider-quiz__error" role="alert">' +
          'This quiz option is currently unavailable.' +
          '</p>' +
          '</div>'
      );
    }

    var options = followup.answers
      .map(function (item, index) {
        var selected =
          state.detail === item.value
            ? ' is-selected'
            : '';

        var icon = getDetailIcon(item, index);

        var imageHtml = icon
          ? '<img src="' +
            escapeHtml(icon) +
            '" alt="">'
          : '';

        return (
          '<button type="button" ' +
          'class="vl-homepage-rider-quiz__option ' +
          'vl-homepage-rider-quiz__option--detail' +
          selected +
          '" ' +
          'data-detail="' +
          escapeHtml(item.value) +
          '">' +

          imageHtml +

          '<span class="vl-homepage-rider-quiz__option-label">' +
          escapeHtml(item.label) +
          '</span>' +

          '</button>'
        );
      })
      .join('');

    return shell(
      intro(true) +

        '<div class="vl-homepage-rider-quiz__main">' +

        '<h3 class="vl-homepage-rider-quiz__question">' +
        escapeHtml(followup.question) +
        '</h3>' +

        '<div class="vl-homepage-rider-quiz__options ' +
        'vl-homepage-rider-quiz__options--detail">' +
        options +
        '</div>' +

        '</div>'
    );
  }

  /**
   * ============================================================
   * STEP 3 - DYNAMIC RESULT
   * ============================================================
   */

  function resultStep() {
    var result = calculateResult();

    /**
     * 不允许在没有合法结果的情况下展示一个默认动物。
     */
    if (!result) {
      state.step = 2;

      return shell(
        intro(true) +

          '<div class="vl-homepage-rider-quiz__main">' +

          '<p class="vl-homepage-rider-quiz__error" role="alert">' +
          'We couldn\'t determine your rider type. Please choose an option again.' +
          '</p>' +

          '</div>'
      );
    }

    var submitLabel = state.submitting
      ? config.copy.submitting
      : config.copy.submit;

    var animalName = result.title.replace(/^The\s+/, '');
    var resultPrompt = String(config.copy.resultPrompt || '')
      .replace('{{animal}}', animalName);

    var status = state.submitted
      ? '<p class="vl-homepage-rider-quiz__status" ' +
        'role="status" aria-live="polite">' +
        escapeHtml(config.copy.success) +
        '</p>'
      : '';

    return shell(
      '<div class="vl-homepage-rider-quiz__intro">' +

        '<div class="vl-homepage-rider-quiz__result-badge" ' +
        'aria-hidden="true">' +
        escapeHtml(result.emoji) +
        '</div>' +

        '<div>' +

        '<h2 id="vl-homepage-rider-quiz-title" ' +
        'class="vl-homepage-rider-quiz__result-title">' +
        escapeHtml(result.title) +
        '</h2>' +

        '<p class="vl-homepage-rider-quiz__result-subtitle">' +
        escapeHtml(result.personality) +
        '</p>' +

        '</div>' +

        '</div>' +

        '<div class="vl-homepage-rider-quiz__main">' +

        '<div class="vl-homepage-rider-quiz__result">' +

        '<h3 class="vl-homepage-rider-quiz__result-prompt">' +
        escapeHtml(resultPrompt) +
        '</h3>' +

        '<form data-action="submit" novalidate>' +

        '<input ' +
        'class="vl-homepage-rider-quiz__email" ' +
        'type="email" ' +
        'name="email" ' +
        'value="' +
        escapeHtml(state.email) +
        '" ' +
        'placeholder="' +
        escapeHtml(config.copy.emailPlaceholder) +
        '" ' +
        'autocomplete="email" ' +
        'required' +
        (state.submitted ? ' disabled' : '') +
        '>' +

        '<button ' +
        'class="vl-homepage-rider-quiz__submit" ' +
        'type="submit"' +
        (state.submitting || state.submitted
          ? ' disabled'
          : '') +
        '>' +
        escapeHtml(submitLabel) +
        '</button>' +

        '<p class="vl-homepage-rider-quiz__consent">' +
        escapeHtml(config.copy.consent) +
        '</p>' +

        '<p class="vl-homepage-rider-quiz__error" ' +
        'role="alert" aria-live="polite"></p>' +

        status +

        '</form>' +

        '</div>' +

        '</div>'
    );
  }

  function render() {
    if (!state.open) {
      root.innerHTML = '';
      root.hidden = true;
      return;
    }

    if (state.step === 1) {
      root.innerHTML = riderStep();
    } else if (state.step === 2) {
      root.innerHTML = detailStep();
    } else {
      root.innerHTML = resultStep();
    }

    root.hidden = !state.open;

    if (state.open) {
      var focusable = root.querySelector(
        'button, input'
      );

      if (focusable) {
        focusable.focus();
      }
    }
  }

  /**
   * ============================================================
   * OPEN / CLOSE
   * ============================================================
   */

  function openAfterGate(group) {
    var selectedGroup =
      config.groups[
        group || root.dataset.defaultGroup
      ];

    if (!selectedGroup) {
      return false;
    }

    if (selectedGroup.type === 'klaviyo_form') {
      var isMobile = window.matchMedia &&
        window.matchMedia('(max-width: 749px)').matches;
      var formId = isMobile
        ? selectedGroup.mobileFormId
        : selectedGroup.desktopFormId;

      if (
        !formId ||
        formId.indexOf(
          'FORM_PENDING'
        ) === 0
      ) {
        return false;
      }

      window._klOnsite =
        window._klOnsite || [];

      state.activeKlaviyoFormId = formId;

      var formCoordinator = getCoordinator();
      if (formCoordinator &&
          typeof formCoordinator.markFormTriggered === 'function') {
        formCoordinator.markFormTriggered({
          experimentGroup: group || root.dataset.defaultGroup,
          formId: formId
        });
      }

      window._klOnsite.push([
        'openForm',
        formId
      ]);

      emit(
        'vl:homepage-rider-quiz-klaviyo-triggered',
        {
          experimentGroup:
            group || root.dataset.defaultGroup,
          formId: formId,
          viewport: isMobile ? 'mobile' : 'desktop'
        }
      );

      return true;
    }

    state.lastFocus = document.activeElement;
    if (selectedGroup.type === 'quiz') restoreQuizProgress();
    state.open = true;
    state.reopenAvailable = false;
    state.actualExposure = true;

    document.body.classList.add(
      'vl-homepage-rider-quiz-open'
    );

    render();

    emit(
      'vl:homepage-rider-quiz-exposure',
      {
        experimentGroup: group || 'quiz',
        surface: 'custom_quiz'
      }
    );

    emit(
      'vl:homepage-rider-quiz-opened',
      {
        experimentGroup: group || 'quiz'
      }
    );

    trackPopupImpression();

    var coordinator = getCoordinator();
    if (coordinator && typeof coordinator.markExposure === 'function') {
      coordinator.markExposure({
        experimentGroup: group || 'quiz',
        surface: 'custom_quiz'
      });
    }

    return true;
  }

  function open(group) {
    if (state.open || state.opening) {
      return Promise.resolve(false);
    }

    var assignedGroup =
      group || root.dataset.defaultGroup;

    if (!config.groups[assignedGroup] || state.assignedGroup) {
      return Promise.resolve(false);
    }

    var coordinator = getCoordinator();
    if (coordinatorIsRequired()) {
      if (!coordinator ||
          typeof coordinator.claimHomepageAutoOpen !== 'function' ||
          !coordinator.claimHomepageAutoOpen(assignedGroup)) {
        return Promise.resolve(false);
      }
    }

    state.assignedGroup = assignedGroup;
    state.actualExposure = false;

    emit(
      'vl:homepage-rider-quiz-assigned',
      {
        experimentGroup: assignedGroup,
        source: 'ptengine'
      }
    );

    state.opening = true;

    return Promise.resolve()
      .then(function () { return openAfterGate(group); })
      .then(
        function (opened) {
          state.opening = false;
          if (!opened) {
            var coordinator = getCoordinator();
            if (coordinator && typeof coordinator.markOpenFailed === 'function') {
              coordinator.markOpenFailed({ reason: 'experiment_popup_open_failed' });
            }
          }
          return opened;
        },
        function (error) {
          state.opening = false;
          var coordinator = getCoordinator();
          if (coordinator && typeof coordinator.markOpenFailed === 'function') {
            coordinator.markOpenFailed({ reason: 'experiment_popup_open_error' });
          }
          throw error;
        }
      );
  }

  function openManual(group) {
    if (state.open || state.opening || state.submitted) {
      return Promise.resolve(false);
    }

    var assignedGroup = group || root.dataset.defaultGroup;
    if (!config.groups[assignedGroup]) return Promise.resolve(false);

    state.assignedGroup = assignedGroup;
    state.actualExposure = false;
    state.opening = true;

    return Promise.resolve()
      .then(function () { return openAfterGate(assignedGroup); })
      .then(function (opened) {
        state.opening = false;
        return opened;
      }, function (error) {
        state.opening = false;
        throw error;
      });
  }

  // Compatibility entry: the global coordinator now owns eligibility.
  function startEligibility() {
    var coordinator = getCoordinator();
    if (!coordinator || typeof coordinator.start !== 'function') {
      return Promise.resolve(false);
    }

    return coordinator.start();
  }

  function close(closeMethod) {
    if (!state.open) return false;

    var closedAt = closeStepName();
    state.open = false;

    var assignedConfig = state.assignedGroup
      ? config.groups[state.assignedGroup]
      : null;

    state.reopenAvailable = Boolean(
      !state.submitted &&
      !state.reopenDismissed &&
      assignedConfig &&
      assignedConfig.type === 'quiz'
    );

    persistQuizProgress();

    document.body.classList.remove(
      'vl-homepage-rider-quiz-open'
    );

    render();

    if (
      state.lastFocus &&
      state.lastFocus.focus
    ) {
      state.lastFocus.focus();
    }

    emit(
      'vl:homepage-rider-quiz-closed',
      {
        step: state.step
      }
    );

    var coordinator = getCoordinator();
    if (coordinator && typeof coordinator.markClosed === 'function') {
      coordinator.markClosed({ surface: 'custom_quiz' });
    }

    trackPopupClosed(closeMethod || 'api', closedAt);
    scheduleBannerImpression();
    return true;
  }

  function reopen() {
    var coordinator = getCoordinator();
    if (!coordinator || typeof coordinator.reopenManually !== 'function') {
      return Promise.resolve(false);
    }
    return coordinator.reopenManually();
  }

  function dismissReopen() {
    var coordinator = getCoordinator();
    if (!coordinator || typeof coordinator.dismissReopen !== 'function') {
      return false;
    }
    return coordinator.dismissReopen();
  }

  /**
   * ============================================================
   * EXISTING KLAVIYO SUBMIT LOGIC
   * ============================================================
   */

  function getQuizProperties() {
    var result = calculateResult();
    if (!result) throw new Error('Quiz result is incomplete.');
    return {
      rider_type: state.riderType,
      rider_detail: state.detail,
      rider_segment: result.riderSegment,
      animal_rider_type: result.animalRiderType,
      personality_copy: result.personality,
      control_label: result.controlLabel,
      recommended_model: result.recommendedModel,
      recommended_model_label: result.recommendedModelLabel,
      email_content_segment: result.emailContentSegment,
      mapping_version: result.mappingVersion,
      quiz_source: 'homepage',
      quiz_version: '2'
    };
  }

  function buildSubscriptionPayload(email) {
    var klaviyoConfig = getKlaviyoConfig();
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: klaviyoConfig.customSource || 'Homepage rider quiz',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } }
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: klaviyoConfig.listId } }
        }
      }
    };
  }

  function createClientProfile(email, properties) {
    var klaviyoConfig = getKlaviyoConfig();
    return fetch(
      'https://a.klaviyo.com/client/profiles/?company_id=' +
        encodeURIComponent(klaviyoConfig.companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          Accept: 'application/vnd.api+json',
          revision: '2026-07-15'
        },
        body: JSON.stringify({
          data: {
            type: 'profile',
            attributes: { email: email, properties: properties }
          }
        })
      }
    ).then(function (response) {
      if (!response.ok) {
        throw new Error('Klaviyo profile save failed with status ' + response.status);
      }
      // 202 can have no body. No profile ID lookup is needed.
      return response;
    });
  }

  function subscribeToKlaviyo(email) {
    var klaviyoConfig = getKlaviyoConfig();
    if (!klaviyoConfig.companyId || !klaviyoConfig.listId) {
      return Promise.reject(new Error('Klaviyo subscription is not configured.'));
    }
    // Snapshot the answers before either request starts.
    var properties = getQuizProperties();
    emit('vl:homepage-rider-quiz-subscription-started', {
      listId: klaviyoConfig.listId
    });
    return createClientProfile(email, properties).then(function () {
      return fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' +
          encodeURIComponent(klaviyoConfig.companyId),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            Accept: 'application/vnd.api+json',
            revision: '2026-07-15'
          },
          body: JSON.stringify(buildSubscriptionPayload(email))
        }
      );
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Klaviyo subscription failed with status ' + response.status);
      }
      emit('vl:homepage-rider-quiz-subscription-succeeded', {
        listId: klaviyoConfig.listId
      });
      return response;
    });
  }

  function recordKlaviyoQuiz(email) {
    // Profile properties have already been saved by the REST request.
    // Identify only to associate the optional completion event with this email.
    var profile = { email: email };

    var eventProperties = getQuizProperties();

    try {
      if (
        window.klaviyo &&
        typeof window.klaviyo.identify ===
          'function' &&
        typeof window.klaviyo.track ===
          'function'
      ) {
        Promise.resolve(window.klaviyo.identify(profile)).then(function () {
          return window.klaviyo.track('Homepage Rider Quiz Submitted', eventProperties);
        }).catch(function () {
          // Event tracking must not turn an accepted subscription into a failure.
        });

        return;
      }
    } catch (error) {}

    window._learnq =
      window._learnq || [];

    window._learnq.push([
      'identify',
      profile
    ]);

    window._learnq.push([
      'track',
      'Homepage Rider Quiz Submitted',
      eventProperties
    ]);
  }

  function getEmailValue(form) {
    var input =
      form.querySelector(
        'input[name="email"]'
      );

    state.email = input
      ? input.value.trim()
      : '';

    return state.email;
  }

  function showSubmitError(message) {
    var submitError =
      root.querySelector(
        '.vl-homepage-rider-quiz__error'
      );

    if (submitError) {
      submitError.textContent = message;
    }
  }

  function showSubmitSuccess() {
    state.submitting = false;
    state.submitted = true;

    render();
  }

  function showSubmitFailure() {
    state.submitting = false;

    render();

    showSubmitError(
      config.copy.submitError
    );
  }

  function submitQuiz(form) {
    var email =
      getEmailValue(form);

    var error =
      form.querySelector(
        '.vl-homepage-rider-quiz__error'
      );

    /**
     * 额外确保当前结果仍然有效。
     */
    if (!calculateResult()) {
      if (error) {
        error.textContent =
          'Please complete the quiz first.';
      }

      return;
    }

    if (
      !email ||
      !form.checkValidity()
    ) {
      if (error) {
        error.textContent =
          'Please enter a valid email address.';
      }

      return;
    }

    error.textContent = '';

    state.submitting = true;

    render();

    emit(
      'vl:homepage-rider-quiz-submit-started',
      {
        riderType: state.riderType,
        riderDetail: state.detail
      }
    );

    subscribeToKlaviyo(email)
      .then(function () {
        recordKlaviyoQuiz(email);

        showSubmitSuccess();

        trackPopupCompleted();

        var coordinator = getCoordinator();
        if (coordinator && typeof coordinator.markCompleted === 'function') {
          coordinator.markCompleted({ surface: 'custom_quiz' });
        }

        emit(
          'vl:homepage-rider-quiz-submitted',
          {
            riderType:
              state.riderType,
            riderDetail:
              state.detail
          }
        );
      })
      .catch(function (error) {
        showSubmitFailure();

        emit(
          'vl:homepage-rider-quiz-subscription-failed',
          {
            message:
              error && error.message
                ? error.message
                : 'unknown_error'
          }
        );

        emit(
          'vl:homepage-rider-quiz-submit-failed',
          {
            riderType:
              state.riderType,
            riderDetail:
              state.detail
          }
        );
      });
  }

  /**
   * ============================================================
   * CLICK HANDLER
   * ============================================================
   */

  root.addEventListener(
    'click',
    function (event) {
      var target =
        event.target.closest(
          '[data-action="close"], [data-rider], [data-detail]'
        );

      if (!target) {
        return;
      }

      /**
       * CLOSE
       */
      if (
        target.dataset.action ===
        'close'
      ) {
        close('close_button');
        return;
      }

      /**
       * STEP 1
       *
       * rider type -> dynamic followup
       */
      if (target.dataset.rider) {
        var newRiderType =
          target.dataset.rider;

        /**
         * 确保 rider type 合法。
         */
        if (
          !getFollowupConfig(
            newRiderType
          )
        ) {
          return;
        }

        /**
         * 第一问变化必须清空旧的第二问和结果。
         */
        if (
          state.riderType !==
          newRiderType
        ) {
          resetDetailResult();
        }

        state.riderType =
          newRiderType;

        var recommendation = RECOMMENDATION_CONFIG[state.riderType];
        state.recommendedModel = recommendation
          ? recommendation.model
          : null;
        state.recommendedModelLabel = recommendation
          ? recommendation.label
          : null;

        state.step = 2;

        try {
          sessionStorage.setItem(
            'vl-homepage-rider-type',
            state.riderType
          );
        } catch (error) {}

        emit(
          'vl:homepage-rider-type-selected',
          {
            riderType:
              state.riderType,
            recommendedModel:
              state.recommendedModel,
            bannerVariantKey:
              recommendation
                ? recommendation.bannerVariantKey
                : null,
            mappingVersion: '2'
          }
        );

        trackPopupAnswer('q1', state.riderType, 1);

        personalizeHomepageBanner(
          recommendation
            ? recommendation.bannerVariantKey
            : state.riderType
        );

        persistQuizProgress();

        render();

        return;
      }

      /**
       * STEP 2
       *
       * detail -> rider segment -> animal result
       */
      if (target.dataset.detail) {
        var newDetail =
          target.dataset.detail;

        /**
         * 防止旧 DOM / 非当前分支答案进入结果。
         */
        if (
          !isValidDetail(
            state.riderType,
            newDetail
          )
        ) {
          return;
        }

        state.detail =
          newDetail;

        /**
         * 计算最终结果。
         */
        if (!updateResultState()) {
          state.step = 2;

          render();

          return;
        }

        state.step = 3;

        emit(
          'vl:homepage-rider-detail-selected',
          {
            riderDetail:
              state.detail,
            riderSegment:
              state.riderSegment,
            animalRiderType:
              state.animalRiderType,
            recommendedModel:
              state.recommendedModel,
            emailContentSegment:
              state.emailContentSegment,
            mappingVersion: '2'
          }
        );

        trackPopupAnswer('q2', state.detail, 2);

        persistQuizProgress();

        render();
      }
    }
  );

  /**
   * ============================================================
   * FORM
   * ============================================================
   */

  root.addEventListener(
    'submit',
    function (event) {
      if (
        !event.target.matches(
          '[data-action="submit"]'
        )
      ) {
        return;
      }

      event.preventDefault();

      if (
        state.submitting ||
        state.submitted
      ) {
        return;
      }

      submitQuiz(event.target);
    }
  );

  root.addEventListener(
    'input',
    function (event) {
      if (
        event.target.matches(
          'input[name="email"]'
        )
      ) {
        state.email =
          event.target.value;
      }
    }
  );

  function normalizeAnswerValue(value) {
    return String(value == null ? '' : value)
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function metadataContainsAnswer(value, normalizedAnswers, depth) {
    if (depth > 5 || value == null) return null;

    if (typeof value === 'string' || typeof value === 'number') {
      var normalized = normalizeAnswerValue(value);
      return normalizedAnswers[normalized] || null;
    }

    if (Array.isArray(value)) {
      for (var i = 0; i < value.length; i++) {
        var arrayMatch = metadataContainsAnswer(
          value[i],
          normalizedAnswers,
          depth + 1
        );
        if (arrayMatch) return arrayMatch;
      }
      return null;
    }

    if (typeof value === 'object') {
      var keys = Object.keys(value);
      for (var j = 0; j < keys.length; j++) {
        var keyMatch = normalizedAnswers[normalizeAnswerValue(keys[j])];
        if (keyMatch) return keyMatch;

        var objectMatch = metadataContainsAnswer(
          value[keys[j]],
          normalizedAnswers,
          depth + 1
        );
        if (objectMatch) return objectMatch;
      }
    }

    return null;
  }

  function getKlaviyoAnswer(groupConfig, metadata) {
    var answerMap = groupConfig && groupConfig.answerMap;
    if (!answerMap || !metadata) return null;

    var normalizedAnswers = {};
    Object.keys(answerMap).forEach(function (label) {
      normalizedAnswers[normalizeAnswerValue(label)] = answerMap[label];
      normalizedAnswers[normalizeAnswerValue(answerMap[label])] = answerMap[label];
    });

    return metadataContainsAnswer(metadata, normalizedAnswers, 0);
  }

  /**
   * ============================================================
   * KLAVIYO FORM ANALYTICS
   * ============================================================
   */

  window.addEventListener(
    'klaviyoForms',
    function (event) {
      var detail =
        event && event.detail
          ? event.detail
          : {};

      if (!detail.formId || !state.assignedGroup) {
        return;
      }

      var assignedConfig =
        config.groups[
          state.assignedGroup
        ];

      if (
        !assignedConfig ||
        assignedConfig.type !==
          'klaviyo_form' ||
        state.activeKlaviyoFormId !==
          detail.formId
      ) {
        return;
      }

      if (detail.type === 'stepSubmit') {
        var answerId = getKlaviyoAnswer(
          assignedConfig,
          detail.metaData || detail.metadata
        );

        if (answerId) {
          trackPopupAnswer(
            assignedConfig.questionId,
            answerId,
            1
          );
        }
        return;
      }

      if (detail.type === 'submit') {
        trackPopupCompleted();
        var completedCoordinator = getCoordinator();
        if (completedCoordinator &&
            typeof completedCoordinator.markCompleted === 'function') {
          completedCoordinator.markCompleted({
            formId: detail.formId,
            surface: 'klaviyo_form'
          });
        }
        return;
      }

      if (detail.type === 'close') {
        trackPopupClosed('klaviyo_close', 'klaviyo_form');
        var closedCoordinator = getCoordinator();
        if (closedCoordinator &&
            typeof closedCoordinator.markClosed === 'function') {
          closedCoordinator.markClosed({
            formId: detail.formId,
            surface: 'klaviyo_form'
          });
        }
        return;
      }

      if (detail.type !== 'open') return;

      state.actualExposure = true;

      var coordinator = getCoordinator();
      if (coordinator && typeof coordinator.markExposure === 'function') {
        coordinator.markExposure({
          experimentGroup: state.assignedGroup,
          formId: detail.formId,
          surface: 'klaviyo_form'
        });
      }

      emit(
        'vl:homepage-rider-quiz-exposure',
        {
          experimentGroup:
            state.assignedGroup,
          surface: 'klaviyo_form',
          formId: detail.formId
        }
      );

      emit(
        'vl:homepage-rider-quiz-klaviyo-opened',
        {
          experimentGroup:
            state.assignedGroup,
          formId: detail.formId
        }
      );

      trackPopupImpression();
    }
  );

  /**
   * ESC
   */

  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key === 'Escape' &&
        state.open
      ) {
        close('escape_key');
      }
    }
  );

  /**
   * ============================================================
   * PUBLIC API
   * ============================================================
   */

  window.VLHomepageRiderQuiz =
    window.VLHomepageRiderQuiz || {
      open: open,
      openManual: openManual,
      close: close,
      reopen: reopen,
      refreshBanner: function (key) {
        var recommendation = RECOMMENDATION_CONFIG[state.riderType];
        return personalizeHomepageBanner(
          key || (recommendation && recommendation.bannerVariantKey)
        );
      },
      startEligibility: startEligibility,

      getState: function () {
        var coordinator = getCoordinator();
        var coordinatorState = coordinator && typeof coordinator.getState === 'function'
          ? coordinator.getState()
          : null;

        return {
          step: state.step,

          riderType:
            state.riderType,

          riderDetail:
            state.detail,

          riderSegment:
            state.riderSegment,

          animalRiderType:
            state.animalRiderType,

          personalityCopy:
            state.personalityCopy,

          controlLabel:
            state.controlLabel,

          recommendedModel:
            state.recommendedModel,

          recommendedModelLabel:
            state.recommendedModelLabel,

          emailContentSegment:
            state.emailContentSegment,

          mappingVersion: '2',

          gateStatus: coordinatorState ? coordinatorState.status : 'coordinator_unavailable',
          eligibilityStatus: coordinatorState ? coordinatorState.ptStatus : 'coordinator_unavailable',
          gateReason: coordinatorState ? coordinatorState.gateReason : 'coordinator_unavailable',
          identified: coordinatorState ? coordinatorState.identified : null,
          membershipResult: null,
          implementationVersion: 'welcome-coordinator-v2',
          welcomeDecision: coordinatorState ? coordinatorState.decision : null,

          assignedGroup:
            state.assignedGroup,

          actualExposure:
            state.actualExposure,

          activeKlaviyoFormId:
            state.activeKlaviyoFormId,

          reopenAvailable: coordinatorState && coordinatorState.decision
            ? coordinatorState.decision.reopenAvailable === true
            : state.reopenAvailable,

          reopenDismissed: coordinatorState && coordinatorState.decision
            ? coordinatorState.decision.reopenDismissed === true
            : state.reopenDismissed,

          analytics: {
            enabled: analyticsEnabled(),
            answeredCount: answeredCount(),
            completed: analyticsState.completed,
            popupImpressionCount: analyticsState.popupImpressionCount,
            gtagSentCount: analyticsState.gtagSentCount,
            gtagFailedCount: analyticsState.gtagFailedCount,
            bannerContentId: analyticsState.banner.contentId,
            bannerApplied: analyticsState.banner.applied,
            bannerStatus: analyticsState.banner.status,
            bannerLastError: analyticsState.banner.lastError,
            bannerDeviceResults: mergeProperties(
              {},
              analyticsState.banner.deviceResults
            ),
            bannerImpressionSent: analyticsState.banner.impressionSent
          }
        };
      }
    };

  root.hidden = true;
})();
